import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../header/header.component';
import { LoaderComponent } from '../../loader/loader.component';
import { SidebarComponent } from '../../sidebar/sidebar.component';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
  imports: [HeaderComponent, SidebarComponent, LoaderComponent, RouterOutlet],
})
export class ContentLayoutComponent {
  permission: boolean = false;
  isNotificationVisible: boolean = true;
  constructor() {}
  scrolled: boolean = false;
}
